// extracted by mini-css-extract-plugin
module.exports = {"roid04":"roid04-module--roid04--3qUOI","box":"roid04-module--box--2vr0U","itemrow":"roid04-module--itemrow--1X--Y","itemcol":"roid04-module--itemcol--1eh5b"};